import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@/components/common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.CTO_AS_A_SERVICE)

 const CTO_CAPABILITIES = [
  {
    title: 'Technology Strategy & Roadmapping',
    description: 'Develop a technology strategy and roadmap aligned with your business goals, product vision, and growth plans.',
  },
  {
    title: 'Software Architecture & Technology Stack',
    description: 'Evaluate and define application architecture, technology stacks, platforms, integrations, and technical standards.',
  },
  {
    title: 'Nurture Engineering Team & Guidance on the Processes',
    description: 'Help establish effective development methodologies, engineering practices, team structures, code quality standards, and delivery processes.',
  },
  {
    title: 'AI & Emerging Technology Strategy',
    description: 'Evaluate where AI, automation, data, cloud adoption and other emerging technologies can create practical business value.',
  },
  {
    title: 'Technology Due Diligence',
    description: 'Assess existing applications, architecture, codebases, infrastructure, security, technical debt, and scalability to identify strengths, risks, and improvement opportunities.',
  },
  {
    title: 'Vendor & Technology Evaluation',
    description: 'Support technology selection and vendor evaluation to ensure solutions align with technical requirements, business objectives, and long-term plans.',
  },
]

const CTO_BENEFIT = [
  {title: 'Startups & Early-Stage Businesses',     desc: 'Build the right technology foundation from the beginning, validate technical decisions, and avoid expensive architectural mistakes as the product evolves.' },
  {  title: 'Growing Businesses',      desc: 'Scale your engineering capabilities, introduce stronger technology governance, and establish processes that support increasing product and business complexity.' },
  { title: 'Established Organizations',           desc: 'Bring experienced technology leadership to modernization initiatives, digital transformation programs, new product development, or strategic technology projects.' },
  { title: 'Businesses Without a Full-Time CTO',  desc: 'Gain access to senior technology expertise when you need strategic leadership but do not require a permanent executive technology role.' },
  
]

const CTO_BUSINESS_BENEFIT = [
  {title: 'Experienced Technology Leadership',desc:'Access senior-level technology expertise without the commitment and cost associated with hiring a full-time CTO.'},
  {title: 'Greater Technology Clarity',desc:'Bring structure and direction to complex technology decisions, helping your organization move forward with greater confidence.'},
  {title: 'Smarter Technology Investment', desc:'Prioritize technology initiatives based on business value, technical requirements, risk, and long-term scalability.'},
  { title: 'Faster Product & Engineering Decisions',desc:'Reduce technology bottlenecks by having experienced technical leadership available to evaluate challenges and guide critical decisions.'},
  { title: 'Reduced Technical Risk',desc:'Identify architectural limitations, technical debt, security concerns, scalability issues, and other technology risks earlier.'},
  { title: 'Technology That Scales With Your Business',desc:'Build a technology foundation that can evolve alongside your products, customers, teams, and business objectives.'},
]
export default function CTOService() {
  

  return (<>
   {/* <MetaInfo
       title="CTO as a Service | Web Application Security | CruxBytes"
        description="CruxBytes CTO as a Service gives you flexible technology leadership: technology strategy, architecture, engineering team guidance, AI strategy, due diligence, and vendor evaluation."
        keywords="CTO as a Service, fractional CTO, technology consulting, technology strategy, software architecture, technology due diligence, CruxBytes"
        url={`https://www.cruxbytes.com${ROUTES.CTO_AS_A_SERVICE}`}
      /> */}
       <MetaInfo
      title={label} 
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Application Consulting -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* CTO as a Service */}
              {label}
              </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Empower your business with expert CTO advisory for smarter technology decisions. */}
             {pageDesc}
             </p>
             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>

{/* Section 1 */}
<section className="bg-linear-gradient-light section-py text-center" >
      <div className="container">
           

        {/* Row 2 — */}
         <p  data-aos="fade-up"  >
             Growing businesses often need strong technology leadership but may not require—or be ready to hire—a full-time Chief Technology Officer.
         </p>
          <p  data-aos="fade-up" data-aos-delay={100}>
             CruxBytes provides CTO as a Service to give organizations access to experienced technology leadership on a flexible basis. We help businesses make informed technology decisions, establish a clear technical direction, manage engineering priorities, and build technology foundations that support long-term growth.
         </p>
        
       
           <div className="text-highlight-light" data-aos="fade-up" data-aos-delay={200}>  
            Strategic Technology Leadership Without the Cost of a Full-Time CTO
           </div>
            <p  data-aos="fade-up" data-aos-delay={300}>
             Whether you are a startup building your first product, a growing company scaling its technology function, or an established business undergoing digital transformation, our CTO advisory services can provide the technical leadership you need.
            </p>           
            
    
            <div className="section-header pt-4 mb-4" data-aos="fade-up" data-aos-delay={400}>
              <h3 id="cto-capabilities-heading">Our CTO as a Service Capabilities</h3>
              <p className="section-subheading">
                Our fractional CTO services can support different aspects of your technology organization:
              </p>
            </div>
                  <ul className="deliverables-grid--centered flip-grid">
          {CTO_CAPABILITIES.map((item, i) => (
            <li
              key={item.title}
              className="flip-card"
              tabIndex={0}
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 150}
            >
              <div className="flip-card__inner">
                <div className="flip-card__face">
                  {/* <span  aria-hidden="true">
                    <i className={`fa-solid ${item.icon}`} />
                  </span> */}
                  <div className="flip-card__title">{item.title}</div>
                </div>
                <div className="flip-card__face flip-card__face--back">
                  {/* <span  aria-hidden="true">
                    <i className={`fa-solid ${item.icon}`} />
                  </span> */}
                  <p className="flip-card__desc">{item.description}</p>
                </div>
              </div>
            </li>
          ))}
        </ul>
          </div>
        </section>

        {/* section 2 */}
    <section className="bgs-section--tint section-py" ria-labelledby="cto-benefit-heading" >
      <div className="container">
          <div className="section-header" data-aos="fade-up">
              <h2 id="cto-benefit-heading">Who Can Benefit From CTO as a Service?</h2>
             
            </div>

       
             <div className="wcs-grid wcs-grid--3">
          {CTO_BENEFIT.map((card, i) => (
            <div
              key={card.title}
              className="wcs-card-offer"
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 100}
            >
              
              <h3 className="wcs-offer-title">{card.title}</h3>
              <p className="wcs-offer-desc">{card.desc}</p>
            </div>
          ))}
        </div>
        <p className="text-highlight pt-4" data-aos="fade-up">
          Let's discuss your technology goals and build a roadmap for what's next.
        </p>
        <div className="text-center pt-4">
          <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-right">
            Get Started
          </Button>
        </div>
      </div>
    </section>


    {/* Section3 */}
 <section
      id="strengths"
      className="about-us-section section-py stack-section "
      aria-labelledby="strengths-heading"
      data-aos="fade-up"
    >   <div className='container'> 
    
      <div className="sc-ai-row sc-tm-row--sticky-heading">

      <div className="sc-tm-content" data-aos="fade-left">
       
     <h2 id="impact-heading" data-aos="fade-up">
            <span className="impact-heading-dark">Business Benefits of</span>
            <span className="impact-heading-light">CTO as a Service</span>
          </h2>
      </div>
      <div  data-aos="fade-right">
       <div className="contact-form-wrap">
  <ul className="check-list">
    {CTO_BUSINESS_BENEFIT.map((card, i) => (
      <li
        key={card.title}
        data-aos="fade-up"
        data-aos-delay={(i % 3) * 80}
      >
        {/* <i className="fa-solid fa-circle-check check-list-icon" aria-hidden="true" /> */}
        <i className="fa-regular fa-thumbs-up check-list-icon" aria-hidden="true" />
        {/* <i className="fa-solid fa-star check-list-icon" aria-hidden="true" /> */}
        <div>
          <p className="wcs-title text-secondary">{card.title}</p>
          <p className="wcs-desc">{card.desc}</p>
        </div>
      </li>
    ))}
  </ul>
</div>
      </div>

    </div>
    </div>  
    </section>

     {/* Section4 */}
      <section className=" section-py text-center" aria-labelledby="bgs-reach-heading3">
      <div className="container">
        <div data-aos="fade-up">
          <h2 id="bgs-reach-heading3">
           Why Choose CruxBytes as Your Technology Partner?
          </h2>
        </div>     

        {/* Row 2 — */}
        <div className="bgs-row bgs-row--text-only" data-aos="fade-up">
          <div >           
           
            <p  >
             CTO leadership should go beyond strategy documents and presentations. At CruxBytes, our technology guidance is backed by hands-on experience across software engineering, cloud, AI, data, application modernization, DevOps, quality engineering, and technology operations.
            </p>
            <p >
              This allows us to look at your technology from both a strategic and practical perspective—helping you define what should be done, why it matters, and how it can be executed.
             Our engagement can complement your existing leadership and engineering teams or provide technology direction where an internal CTO function is not yet in place.
</p>           
          </div>
        </div>
      <div>      
      </div>
      </div>
    </section>
         <TransformBanner />
         </main>
         </>
  )
}